import React, {useState, useEffect} from "react"
import Texture from '../../assets/texture.png'


function CFTexture() {

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById("hero");

     if (hero) {
  const triggerPoint = hero.offsetTop + hero.offsetHeight;
  setScrolled(window.scrollY >= triggerPoint);
}
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <div className="regd">
      <nav id="mainNav" className={scrolled ? "scrolled" : ""}>
        <span className="andeshead" style={{color:'white'}}>
        This Funding Platform is Offered by Texture Capital Inc</span><img className='andesheadlogo' src={Texture} style={{width:'115px'}}/>
  <a href="#hero" class="nav-logo">All American Energy</a>
        <span className="logo-mark" style={{ display: 'none' }}>logo</span> 
        
  <div class="hamburger" id="hamburger">
    <span></span>
    <span></span>
    <span></span>
  </div>

  <div class="nav-menu" id="navMenu">
    <ul class="nav-links">
      <li><a href="#intro">Company</a></li>
      <li><a href="#reasons">Why Invest</a></li>
      <li><a href="#business">Business</a></li>
      <li><a href="#market">Market</a></li>
      <li><a href="#terms">Offering</a></li>
      <li><a href="#team">Team</a></li>
    </ul>
    <a href="#" class="btn-nav" data-bs-toggle="" data-bs-target="#">Invest Now</a>
  </div>
</nav>
    </div>
  )
}

export default CFTexture